module.exports = __webpack_public_path__ + "static/media/order-in-bulk-badge.fed2363f.svg";